import { Button } from 'src/v2/commonComponents/Button';
import { SUPER_PROJECT_NAME, SVG_SIZE_M } from 'src/constants';
import { Icon } from 'src/components/Icon';
import { Message, QUERY_SEARCH_PARAM, RequestPayloadType } from 'src/types';
import styles from './BoostWithSNButton.module.scss';
import { env } from 'src/env';
import { useGetUser, useMessageByRoundId } from 'src/hooks';
import { FileRequestPayload } from 'src/types/models/FileRequestPayload';
import { useChatHistory } from 'src/hooks';

type BoostWithSNButtonProps = {
  message: Message;
  isDisabled: boolean;
};

export const BoostWithSNButton = ({
  isDisabled,
  message,
}: BoostWithSNButtonProps) => {
  const { isNinjaRetired } = useChatHistory();
  const userMessageData = useMessageByRoundId(
    message?.conversation_id,
    message?.round_id,
  );

  const { isOpenTier } = useGetUser();

  const handleClick = () => {
    if (!!message?.clean_query) {
      const base = `${env.REACT_APP_SUPER_NINJA_URL}${!isOpenTier ? 'dashboard' : ''}`;
      const param = encodeURIComponent(message?.clean_query);
      const attachments =
        userMessageData?.payload_list?.filter(
          (item): item is FileRequestPayload =>
            item.payload_type === RequestPayloadType.FILE,
        ) ?? [];
      const attachmentNames = attachments.map(
        (item) => item.converted_filename,
      );
      const attachmentsQuery = attachmentNames?.length
        ? attachmentNames
            .map((fileName) => `attachments[]=${encodeURIComponent(fileName)}`)
            .join('&')
        : '';

      window.open(
        `${base}?${QUERY_SEARCH_PARAM}=${param}${attachmentsQuery ? `&${attachmentsQuery}` : ''}`,
        '_blank',
      );
    }
  };

  if (isNinjaRetired) {
    return null;
  }

  return (
    <Button
      id="boost-with-sn-button"
      color="secondary-outline"
      onClick={handleClick}
      disabled={isDisabled}
      className={styles.button}
      tooltipContent="AI Agent with a dedicate virtual computer that delivers finished and comprehensive result."
    >
      <Icon type="superNinjaMainIcon" size={SVG_SIZE_M} />
      Boost with {SUPER_PROJECT_NAME}
    </Button>
  );
};
